<template>
  <div class="aboutus">
    <v-parallax
      src="@/assets/header-parallax-1.jpg"
      height="200"
      class="page-header"
    >
      <v-container
        ><h1>
          {{ $t("texts.whoarewe") }}
        </h1></v-container
      >
    </v-parallax>

    <div class="page-content">
      <div class="page-section">
        <h2>{{ $t("texts.aboutus") }}</h2>
        <p style="text-align : justify;">{{ $t("texts.aboutus_content") }}</p>
        <p style="text-align : justify;">{{ $t("texts.aboutus_content2") }}</p>
        <p style="text-align : justify;">{{ $t("texts.aboutus_content3") }}</p>
        <p style="text-align : justify;">{{ $t("texts.aboutus_content4") }}</p>
      </div>

      <div class="page-section">
        <h2>{{ $t("texts.ourcommunity") }}</h2>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            xl="3"
            v-for="statistic in ourCommunityStatistics"
            :key="statistic.text"
          >
            <v-card color="grey lighten-5" elevation="4">
              <v-card-title>
                <v-col cols="4">
                  <v-icon :class="statistic.iconColor" size="72">{{
                    statistic.icon
                  }}</v-icon>
                </v-col>
                <v-col cols="8" class="text-right">
                  <span class="display-2 grey--text text--darken-1">
                    <v-lazy>
                      <animated-number
                        :value="statistic.value"
                        round="1"
                        :duration="3000"
                        :formatValue="formatNumber"
                      />
                    </v-lazy>
                  </span>
                  <br />
                  <span class="body-1 grey--text">
                    {{ statistic.text }}
                  </span>
                </v-col>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <p class="pt-8 font-weight-bold" align="right">
          {{ $t("texts.aboutUsText4") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";

import AnimatedNumber from "animated-number-vue";

export default {
  components: {
    AnimatedNumber
  },

  mounted() {
    this.loadData();
  },

  data() {
    return {
      // Statistics
      statisticsVolunteers: 0,
      statisticsVolunteeringEvents: 0,
      statisticsInternalEntities: 0,
      statisticsExternalEntities: 0
    };
  },

  methods: {
    /**
     * Get statistics.
     * @public
     */
    loadData() {
      // Load form data
      const loadFormData = this.$api({
        url: this.$config.api.route.statisticsAboutUs,
        method: "GET"
      }).then(resp => {
        const {
          volunteers,
          internalEntity,
          externalEntity,
          volunteeringProjects
        } = resp.data;
        this.statisticsVolunteers = volunteers;
        this.statisticsVolunteeringEvents = volunteeringProjects;
        this.statisticsInternalEntities = internalEntity;
        this.statisticsExternalEntities = externalEntity;
      });

      // Async handle loads
      this.$store.dispatch("Util/startLoading");
      Promise.all([loadFormData])
        .catch(() => {
          AppError.handle(new AppError("LOAD_DATA_UNKNOWN"));
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },

    /**
     * Format the number.
     * @param {int} number - number to format.
     * @public
     */
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  },

  computed: {
    /**
     * Get the statistics
     */
    ourCommunityStatistics() {
      return [
        {
          icon: "mdi-account-group",
          iconColor: "primary--text",
          value: this.statisticsVolunteers,
          text: this.$t("texts.volunteers")
        },
        {
          icon: "mdi-calendar-month",
          iconColor: "primary--text",
          value: this.statisticsVolunteeringEvents,
          text: this.$t("texts.volunteeringevents")
        },
        {
          icon: "mdi-badge-account-horizontal",
          iconColor: "primary--text",
          value: this.statisticsInternalEntities,
          text: this.$t("texts.internalentities")
        },
        {
          icon: "mdi-badge-account-horizontal-outline",
          iconColor: "primary--text",
          value: this.statisticsExternalEntities,
          text: this.$t("texts.externalentities")
        }
      ];
    }
  }
};
</script>
